import React, { useEffect, useState } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import { HiOutlineShieldCheck } from "react-icons/hi2";
import { FaCheck } from "react-icons/fa6";
import { GoClock } from "react-icons/go";
import styles from "./thankyou.module.css";
import { Link } from "react-router-dom";
import confettiIcon from "images/headerimges/mis-survey/confetti.svg";
import aishaImage from "images/headerimges/mis-survey/aisha.svg";
import securedIcom from "images/headerimges/mis-survey/cloud-secured.svg";
import navigateIcon from "images/headerimges/mis-survey/navigator.svg";
import { useLongSurveyContent } from "context/mis-long-survey/LongSurveyContext";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "store/features/misSurveySlice";
import { useSendSms } from "api/hooks";
import { secureStorage } from "utils/encryptionUtil";

const ThankyouPage = () => {
	const dispatch = useDispatch();
	const { dispatch: dispatchSurvey } = useLongSurveyContent();
	const { localRespondent } = useSelector((state) => state.misSurvey);
	const [smsError, setSmsError] = useState(false);
    const [smsSuccess, setSmsSuccess] = useState(false);
	const sessionChannel = secureStorage.getSession("::channel::us-mls") || "";
	const isCallCenterPortal = sessionChannel !== "";

	const { sendSms, isLoading } = useSendSms({
		onSuccess: () => {
            setSmsSuccess(true);
            setSmsError(false);
			endSurvey();
		},
		onError: () => {
			setSmsError(true);
		},
	});

	const endSurvey = () => {
		dispatchSurvey({ type: "CLEAR" });
		dispatch(resetState());
		sessionStorage.clear();
		localStorage.clear();
	};

	useEffect(() => {
		if (isCallCenterPortal) {
			console.log("send aisha sms");
		} else {
			endSurvey();
		}
		window.scrollTo({ top: 0, behavior: "smooth" });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleAishaSms = () => {
		sendSms({ phone: localRespondent?.phone_number || "" });
	};

	return (
		<section className={styles.thankyou_container}>
			<img src={confettiIcon} alt="confetti" />
			{isCallCenterPortal && (
				<button
					className="w-full bg-primary py-3 rounded-lg text-white"
					type="button"
					onClick={handleAishaSms}
					disabled={isLoading}
				>
					{isLoading ? "sending sms..." : "send aisha sms"}
				</button>
			)}

			{smsError && (
				<div>
					<p className="text-primary-light text-center mt-2">
						Failed to send SMS, please click on the button below to
						end this survey
					</p>

					<button
						className="w-full border border-primary py-3 rounded-lg text-primary mt-2"
						type="button"
						onClick={endSurvey}
					>
						End this survey
					</button>
				</div>
			)}
			{smsSuccess && (
				<div>
					<p className="text-success text-center mt-2">
						Sms sent successfully! You can close this page.
					</p>
				</div>
			)}

			<p className="mb-2">
				Thank you for participating in this survey, we appreciate your
				time and response.
			</p>
			<section className={styles.thankyou_other_section}>
				<h3>
					<HiOutlineShieldCheck /> About Us
				</h3>
				<p>
					At <span className={styles.highlight}>Sproxil</span>, we
					help protect lives by ensuring access to safe, authentic
					products. Our technology lets you verify medications and
					essential goods, preventing counterfeits.
				</p>

				<div className={styles.sproxil_usp}>
					<h3>
						<HiOutlineShieldCheck /> Stay Safe with{" "}
						<span className={styles.highlight}>Sproxil</span>!
					</h3>

					<p>
						<FaCheck />
						Verify your medicines instantly with our
						scratch-and-text authentication system
					</p>
					<p>
						<FaCheck />
						Shop with confidence knowing your health and safety are
						protected
					</p>
					<p>
						<FaCheck />
						Join millions of people who trust Sproxil for product
						verification and consumer protection!
					</p>
				</div>

				<Link to={"https://sproxil.com/about-us/"}>
					Learn more about Sproxil{" "}
					<IoIosArrowRoundForward color="white" size={24} />
				</Link>
			</section>

			<section className={styles.thankyou_other_section}>
				<img src={aishaImage} alt="aisha" />
				<h3>Got Questions About Medication?</h3>
				<p>AISHA has the answers—quick, reliable, and easy.</p>
				<Link to={"https://aisha.ng/"} target="_blank">
					Ask AISHA Now{" "}
					<IoIosArrowRoundForward color="white" size={24} />
				</Link>
				<div className={styles.aisha_usp}>
					<div>
						<GoClock />
						<p>24/7 Access</p>
					</div>
					<div>
						<img src={securedIcom} alt="secure and private" />
						<p>Secure & Private</p>
					</div>
					<div>
						<img src={navigateIcon} alt="expert guidance" />
						<p>Expert Guidance</p>
					</div>
				</div>
			</section>
		</section>
	);
};

export default ThankyouPage;
